export default __webpack_public_path__ + "static/media/faustin_lake.094ab962.jpg";